export default "__VITE_ASSET__56d5601e__"